import React, { useState } from "react";
import styles from "./styles.module.scss";

function ReadingGlass() {
  const [mobileGlb, setMobileGlb] = useState(false);
  const [desktopAr, setDesktopAr] = useState(false);
  const [mobileAr, setMobileAr] = useState(false);

  const [imageView, setImageView] = useState(true);

  const toggleDesktopAR = () => {
    setDesktopAr(!desktopAr);
    setMobileGlb(false);
    setImageView(false);
  };

  const toggleMobileAR = () => {
    setMobileAr(!mobileAr);
    setMobileGlb(false);
    setImageView(false);
  };

  const [selectedImage, setSelectedImage] = useState(
    "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/render_1.webp"
  );

  const toggleMobileglb = () => {
    setMobileGlb(!mobileGlb);
    setImageView(!selectedImage);
  };

  const handleImageClick = (imageSrc) => {
    setMobileGlb(false);
    setMobileAr(false);
    setDesktopAr(false);
    setSelectedImage(imageSrc);
    setImageView(true);
  };

  return (
    <div>
      <div className={styles.container}>
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/mobile_header.png"
          alt=""
        />

        <div className={styles.renderSection}>
          <p onClick={toggleMobileAR}>Try Before Buy</p>
          {mobileGlb && (
            <iframe
              title="mobileGlb"
              src="https://www.pod.advflr.com/turnaround/urbanoutfitters/reading-glass"
            ></iframe>
          )}

          {mobileAr && (
            <iframe
              title="mobileAr"
              src="https://www.pod.advflr.com/client/vto/frontcamera/01ce031c-bbcc-40b2-a0a5-0478793ec0c7/1ee15629-39c0-4eb9-849b-8dabd1a6729f"
            ></iframe>
          )}

          {imageView && <img src={selectedImage} alt="" />}
        </div>

        <div className={styles.thumbnailSection}>
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/render_1.webp"
            alt=""
            onClick={() =>
              handleImageClick(
                "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/render_1.webp"
              )
            }
          />
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/render_2.webp"
            alt=""
            onClick={() =>
              handleImageClick(
                "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/render_2.webp"
              )
            }
          />

          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/360_thumbnail.webp"
            onClick={toggleMobileglb}
            alt=""
          />
        </div>

        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/mobile_details.webp"
          alt=""
        />
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/mobile_likable.webp"
          alt=""
        />
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/anthropologie/baseball-hat/mobile_footer.webp"
          alt=""
        />
      </div>

      <div className={styles.desktopContainer}>
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/header.webp"
          alt=""
        />

        <div className={styles.mainContainer}>
          <div className={styles.renderSection}>
            <p onClick={toggleDesktopAR}>Try Before Buy</p>

            {mobileGlb && (
              <iframe
                title="mobileGlb"
                src="https://www.pod.advflr.com/turnaround/urbanoutfitters/reading-glass"
              ></iframe>
            )}

            {desktopAr && (
              <iframe
                title="desktopAR"
                src="https://www.pod.advflr.com/client/vto/frontcamera/01ce031c-bbcc-40b2-a0a5-0478793ec0c7/1ee15629-39c0-4eb9-849b-8dabd1a6729f"
              ></iframe>
            )}

            {imageView && <img src={selectedImage} alt="" />}
          </div>

          <div className={styles.cartSection}>
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/details.webp"
              alt=""
            />
          </div>
        </div>

        <div className={styles.thumbnailSection}>
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/render_1.webp"
            alt=""
            onClick={() =>
              handleImageClick(
                "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/render_1.webp"
              )
            }
          />
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/render_2.webp"
            alt=""
            onClick={() =>
              handleImageClick(
                "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/render_2.webp"
              )
            }
          />
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/360_thumbnail.webp"
            onClick={toggleMobileglb}
            alt=""
          />
        </div>

        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/reading-glass/likable.webp"
          alt=""
        />

        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/anthropologie/baseball-hat/footer.webp"
          alt=""
        />
      </div>
    </div>
  );
}

export default ReadingGlass;
